import { Box, Button, Group, Text } from "@mantine/core";
import { OrgPermissions } from "beitary-shared";
import { BBox } from "components";
import { BCan } from "permissions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AppointmentTypesTable } from "./components";

export const AppointmentTypes = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <BBox
      header={
        <Group position="apart">
          <Text size="sm" weight={500}>
            {t("APPOINTMENT_TYPES_LIST")}
          </Text>
          <BCan I="do" a={OrgPermissions.SCHEDULE_CUD}>
            <Button onClick={() => navigate("new")}>{t("ADD_NEW")}</Button>
          </BCan>
        </Group>
      }
    >
      <Box p="xl">
        <AppointmentTypesTable />
      </Box>
    </BBox>
  );
};
